import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { branch, compose, renderNothing, withProps } from 'recompose';

import WithShop from '../../hoc/WithShop';
import withGiftCardBarber from '../hoc/withGiftCardBarber';

export default compose(
  withRouter,
  withGiftCardBarber,
  WithShop,
  connect(
    state => ({
      giftCard: state.giftCard.get('giftCard'),
    }),
  ),
  withProps(props => ({
    brandId: props.location.query.brand,
  })),
  branch(
    props => !props.shop || !props.giftCard,
    renderNothing,
  )
);



// WEBPACK FOOTER //
// ./src/app/giftCard/ViewGiftCard/ViewGiftCardContainer.js